import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <img 
              src="https://static.readdy.ai/image/5705871e133a048fcd13b20b6e4d74bd/26d8c27b87decb516fa51c337abf97bb.jpeg" 
              alt="ESAPCOR Logo" 
              className="h-14 w-auto object-contain"
            />
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <a href="#courses" className={`font-medium transition-colors hover:text-orange-500 ${
              isScrolled ? 'text-gray-700' : 'text-white'
            }`}>Khóa Học</a>
            <a href="#products" className={`font-medium transition-colors hover:text-orange-500 ${
              isScrolled ? 'text-gray-700' : 'text-white'
            }`}>Sản Phẩm</a>
            <a href="#about" className={`font-medium transition-colors hover:text-orange-500 ${
              isScrolled ? 'text-gray-700' : 'text-white'
            }`}>Về Chúng Tôi</a>
            <a href="#contact" className={`font-medium transition-colors hover:text-orange-500 ${
              isScrolled ? 'text-gray-700' : 'text-white'
            }`}>Liên Hệ</a>
          </div>

          <div className="flex items-center gap-4">
            <a href="tel:0902730008" className="hidden md:flex items-center gap-2 px-5 py-2.5 bg-orange-500 text-white rounded-full font-medium hover:bg-orange-600 transition-colors whitespace-nowrap cursor-pointer">
              <i className="ri-phone-fill"></i>
              <span>0902 730 008</span>
            </a>
            <button className="md:hidden w-10 h-10 flex items-center justify-center">
              <i className={`ri-menu-line text-2xl ${isScrolled ? 'text-gray-900' : 'text-white'}`}></i>
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}